import React from 'react'
import { Helmet } from 'react-helmet-async';
import Banner from '../../component/banner';
import Milestones from '../../component/milestones';
import Footer from '../../component/footer';

function Aboutus() {
  return (
    <>
        <Helmet>
            <title>About Us - Shareef Tex</title>
            <meta name="description" content="Head to Toe Safety PPE Supplier. Shareef Tex  is a leading safety product manufacturer" />
            <meta name="keywords" content="Safety PPE, PPE protection, PPE construction, PPE list, types of PPE, PPE store near me, 
            PPE kit, PPE Equipment, ppe wear, Cotton, Fibric, Poly-cotton, Talan safety shoes, PPE detection, PPE equipment near me,
            Talan rigger Boot, Harvik safety Boot, Harvik Electrical Insulating Fireman Boot, Bulldozer Fire Fighting Boot, 
            Robusta 100% non-matallic Boot, Milesttone low ankle safety Boot, Safety Shoes Low Ankle Breathable Leather with 
            Cool comfort Technique, Safety Shoes High Ankle, DUPONT Tyvek Antistatic/Antislip Shoe Cover, SAFETYPLUS SAFETY SHOES S3SRC, 
            Cotton & Poly Cotton, mops, Reflective Tapes Cotton Coverall, Coverall Safety, Coverll Suit, White Coverall, 
            Disposable Coverall, Disposable Suit, Disposable Safety Suit, BULLDOZER FIRE FIGHTING SUIT, Bulldozer Nomex IIIA FR Suit,
            Fire Retardant Turnout Gear Suit, Construction PortWest Reflective Tapes Coverall, High Visibility Ploy-Cotton Shirt,
            High Visibility Ploy-Cotton pants, Breathable and ultra lightweight coverall, High Visibility Ploy-Cotton Coverall, 
            AIRMAX Coverall, DUPONT TYVEK Classic Coverall, Tyvek® 200 Easysafe, Promax Chemical Suit, chemical resistant gloves" />
            {/* <link rel="canonical" href={canonicalLink}></link> */}
        </Helmet>
        <Banner/>
        <Milestones/>
        <Footer/>
  </>
  )
}

export default Aboutus